import { useState, useEffect, useContext } from 'react';
import { systemLanguages } from '../config';
import {UserContext} from '../contexts';
import { nairobiGateway, post } from '../utils/fetch';

export const useLabelsHook = () => {
    const [user] = useContext(UserContext);

    const [isLabelsLoading, setIsLabelsLoading] = useState(true);
    const [errorLabelsLoading, setErrorLabelsLoading] = useState(false);
    const [labels, setLabels] = useState([]);
    const [lastEditData, setLastEditData] = useState({lastUpdate: '', lastEditor: ''});

    useEffect(() => {
        // Fetch labels for ofek workspace (he, ar, en) - no workspace parameter for existing behavior
        const ofekPromise = window.cet.microservices.nairobiapi.label.getLabels({ 
            languages: systemLanguages.join(',') + ',last'
        });
        
        // Fetch labels for ivritil workspace (en)
        const ivritilPromise = window.cet.microservices.nairobiapi.label.getLabels({ 
            languages: 'en',
            workspace: 'ivritil'
        });

        Promise.all([ofekPromise, ivritilPromise]).then(([ofekData, ivritilData]) => {
            var items = [];
            var items_keys = Object.keys(ofekData.he || {});
            
            // Also include keys from ivritil that might not exist in ofek
            var ivritilKeys = Object.keys(ivritilData.en || {});
            ivritilKeys.forEach(key => {
                if (!items_keys.includes(key)) {
                    items_keys.push(key);
                }
            });
            
            for (var i = 0; i < items_keys.length; i++) {
                var item = { key: items_keys[i]};
                // Add ofek languages (he, ar, en)
                for(var j = 0 ; j < systemLanguages.length; j++) {
                    item[systemLanguages[j]] = systemLanguages[j] in ofekData && item.key in ofekData[systemLanguages[j]] ? ofekData[systemLanguages[j]][item.key] : '';
                }
                // Add ivritil column
                item['ivritil'] = 'en' in ivritilData && item.key in ivritilData.en ? ivritilData.en[item.key] : '';
                items.push(item);
            }
            setIsLabelsLoading(false);
            setLabels(items);
    
            if('last' in ofekData) {
                setLastEditData({
                    lastUpdate: ofekData.last.lastUpdate || '',
                    lastEditor: ofekData.last.lastEditor || ''
                });
            }
        }).catch(error => {
            setIsLabelsLoading(false);
            setErrorLabelsLoading(error);
            setLabels([]);
        });

    }, []);

    const clearErrorLabelsLoading = () => {
        setErrorLabelsLoading(false);
    };

    const updateLabels = (updateData) => {
        var now = new window.Date();
        var day = now.getDate();
        var month = (now.getMonth() + 1);
        month = month < 10 ? '0' + month : month;
        var year = now.getFullYear();
        var hours = now.getHours();
        var minutes = now.getMinutes();
        minutes = minutes < 10 ? '0' + minutes : minutes;
        now = day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
        var lastUpdateData = {
            lastUpdate: now,
            lastEditor: user && user.displayName ? user.displayName : '',
        };

        // Separate ivritil changes from ofek changes
        var ofekUpdateData = {};
        var ivritilUpdateData = {};
        
        Object.keys(updateData).forEach(field => {
            if (field === 'ivritil') {
                // IvritIL changes go to ivritil workspace with 'en' as the language key
                ivritilUpdateData['en'] = updateData[field];
            } else if (systemLanguages.includes(field)) {
                // he, ar, en changes go to ofek workspace
                ofekUpdateData[field] = updateData[field];
            }
        });

        var promises = [];

        // Save ofek changes if any (use existing API without workspace param)
        if (Object.keys(ofekUpdateData).length > 0) {
            promises.push(
                window.cet.microservices.nairobiapi.label.setLabels(
                    {...ofekUpdateData, last: lastUpdateData}
                )
            );
        }

        // Save ivritil changes if any (use direct POST with workspace query param)
        if (Object.keys(ivritilUpdateData).length > 0) {
            promises.push(
                post(
                    `${nairobiGateway}/nairobiapi/Label/SetLabels?workspace=ivritil`,
                    {...ivritilUpdateData, last: lastUpdateData}
                )
            );
        }

        var fetch = Promise.all(promises);
        fetch.then(() => {
            setLastEditData({
                lastUpdate: lastUpdateData.lastUpdate,
                lastEditor: lastUpdateData.lastEditor
            });
        });
        return fetch;
    };

    return {
        isLabelsLoading: isLabelsLoading,
        errorLabelsLoading: errorLabelsLoading,
        clearErrorLabelsLoading: clearErrorLabelsLoading,
        labels: labels,
        lastEditData: lastEditData,
        updateLabels: updateLabels
    };
  };
  
